export default __webpack_public_path__ + "static/sloth_card_4-c085ee5dfd37bd4c093f890e7dc98e4f.png";